<template>
    <div class="l-footer">
        <div class="container">
            <div class="content">
                <div class="leftContent">
                    <div class="footer_about footer_section">
                        <h3 class="sectionTitle">MATCHA - JAPAN TRAVEL WEB MAGAZINE</h3>
                        <p class="description">{{ $t("footer.guide_text_short") }}</p>
                    </div>
                </div>
                <div class="rightContent">
                    <div class="footer_sns footer_section">
                        <h3 class="sectionTitle">Official Accounts</h3>
                        <div class="accounts">
                            <a :href="UrlUtils.get_customLink('sns_link_fb', languageName)">
                                <i class="icon-facebook"></i>
                            </a>
                            <a :href="UrlUtils.get_customLink('sns_link_twi', languageName)">
                                <i class="icon-twitter"></i>
                            </a>
                            <a :href="UrlUtils.get_customLink('sns_link_gp', languageName)">
                                <i class="icon-googleplus"></i>
                            </a>
                            <a :href="UrlUtils.get_customLink('sns_link_pin', languageName)">
                                <i class="icon-pinterest"></i>
                            </a>
                            <a :href="UrlUtils.get_customLink('sns_link_ins', languageName)">
                                <i class="icon-instagram"></i>
                            </a>
                            <a :href="UrlUtils.get_customLink('sns_link_yt', languageName)">
                                <i class="icon-youtube"></i>
                            </a>
                            <a :href="constants.MATCHA_SITE+ languageName +'/feed'">
                                <i class="fi flaticon-rss-symbol"></i>
                            </a>
                        </div>

                        <template v-if="['jp', 'tw', 'en', 'th'].includes(this.language)">
                            <h3 class="sectionTitle" style="margin-top: 32px">APP</h3>
                            <div class="applogo">
                                <a
                                    :href="'https://itunes.apple.com/' + this.language + '/app/matcha-japan-travel-magazine/id1292508651?mt=8'"
                                >
                                    <img
                                        :src="'https://matcha-jp.com/renewal/img/appbanner/' + this.language + '.svg'"
                                    >
                                </a>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="leftContent">
                    <div class="footer_company footer_section">
                        <h3 class="sectionTitle">{{ $t('footer.company') }}</h3>
                        <ul class="links">
                            <li>
                                <a :href="$t('footer.about_matcha.url')">
                                    <i class="icon-question"></i>
                                    <span class="name">{{ $t('footer.about_matcha.text') }}</span>
                                </a>
                            </li>
                            <li>
                                <a :href="$t('footer.media_partner.url')">
                                    <i class="icon-handshake"></i>
                                    <span class="name">{{ $t('footer.media_partner.text') }}</span>
                                </a>
                            </li>
                            <li>
                                <a :href="$t('footer.company_profile.url')">
                                    <i class="icon-office"></i>
                                    <span class="name">{{ $t('footer.company_profile.text') }}</span>
                                </a>
                            </li>
                            <li>
                                <a :href="$t('footer.recruit.url')">
                                    <i class="icon-users"></i>
                                    <span class="name">{{ $t('footer.recruit.text') }}</span>
                                </a>
                            </li>
                            <li>
                                <a :href="$t('footer.contact_us.url')">
                                    <i class="icon-envelope"></i>
                                    <span class="name">{{ $t('footer.contact_us.text') }}</span>
                                </a>
                            </li>
                            <li>
                                <a :href="$t('footer.privacy_policy.url')">
                                    <i class="icon-shield"></i>
                                    <span class="name">{{ $t('footer.privacy_policy.text') }}</span>
                                </a>
                            </li>
                            <li>
                                <a :href="$t('footer.terms_of_service.url')">
                                    <i class="icon-padlock"></i>
                                    <span class="name">{{ $t('footer.terms_of_service.text') }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="rightContent">
                    <div class="footer_language footer_section">
                        <h3 class="sectionTitle">{{ $t('Languages') }}</h3>
                        <div class="selectLanguage">
                            <label for="language">
                                <select v-model="language" v-on:change="languageSwitching">
                                    <option value="jp">日本語</option>
                                    <option selected value="en">English</option>
                                    <option value="tw">中文繁體</option>
                                    <option value="th">ภาษาไทย</option>
                                    <option value="ko">한국어</option>
                                    <option value="cn">中文简体</option>
                                    <option value="id">Indonesian</option>
                                    <option value="vn">Việt Nam</option>
                                    <option value="easy">やさしい日本語</option>
                                    <option value="es">Español</option>
                                </select>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <p class="footer_copyright">Copyright © MATCHA, Inc.</p>
        </div>
    </div>
</template>

<script>
import * as constants from "@/constants";
import { mapState, mapGetters, mapMutations } from "vuex";
import UrlUtils from "@/utils/UrlUtils";

export default {
    name: "main_footer",
    data() {
        return {
            constants: constants,
            UrlUtils: UrlUtils,
            language: this.$i18n.locale,
            languageName: this.$store.state.languageName
        };
    },
    computed: {
        ...mapState(["user"])
    },
    methods: {
        languageSwitching: function(l) {
            this.$store.dispatch('switchingLanguage', this.language)
            this.$i18n.locale = this.language;
            this.languageName = this.language;
            document.body.className = this.language;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/MainFooter.vue